export default __webpack_public_path__ + "static/media/cover_template.793e5cbe.png";